import { Pipe, PipeTransform } from '@angular/core';
/*
 * Filters combo by internal Class container variable
 * Usage:
 *   value | filter:string
 * Example:
 *   {{ Ajuntament de .... |  filtre: Ajunta}}
 */
@Pipe({name: 'filterClientSocis'})
export class FilterClientSocisPipe implements PipeTransform {
  transform(items: any[], filtre: string): any {
    if(!items || filtre == '')return items;
    return items.filter(item => {if(!item.nom)return item;else return item["nom"].toLowerCase().indexOf(filtre.toLowerCase()) != -1;});
    }
}